import React from 'react'
import { graphql } from 'react-apollo'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Loader from '../common/Loader'
import Error from '../common/Error'
import FadeInWrapper from '../common/FadeInWrapper'
import BlueLoadingButton from '../common/BlueLoadingButton'
import FullscreenModal from '../common/FullscreenModal'
import SubNav from '../common/SubNav'
import administratorType from '../common/types/administratorType'
import podType from '../common/types/podType'
import PodsQuery from './queries/PodsQuery'
import PodCard from './PodCard'
import NewPodCard from './NewPodCard'

const Container = styled.section`
  position: relative;
  ${props => props.noScroll ? 'hidden' : ''};
`
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 3%;
`
const ControlsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 60px;
`
const Title = styled.h2`
  font-size: 36px;
  font-family: 'Zilla Slab', serif;
  line-height: 42px;
`

export class PodsLayout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentEditedPod: null,
      isCreatePodModalOpen: false
    }
  }
  static propTypes = {
    data: PropTypes.shape({
      administrators: PropTypes.arrayOf(administratorType),
      error: PropTypes.object,
      loading: PropTypes.bool,
      pods: PropTypes.arrayOf(podType)
    })
  }
  onCreatePodToggle = () => {
    const { isCreatePodModalOpen } = this.state
    this.setState({ isCreatePodModalOpen: !isCreatePodModalOpen })
    if (isCreatePodModalOpen) {
      this.setState({ currentEditedPod: null })
    }
  }
  onPodEdit = ({ rid }) => {
    const { pods } = this.props.data
    const currentEditedPod = pods.find(pod => pod.rid === rid)
    this.setState({ currentEditedPod })
    this.onCreatePodToggle()
  }
  render() {
    const { data: { error, loading, pods, administrators } } = this.props
    const { isCreatePodModalOpen, currentEditedPod } = this.state
    const subNavProps = {
      leftLink: { title: 'Loan Assignments', href: '/admin/genie' },
      rightLink: { title: 'Pods' }
    }
    if (loading) {
      return (
        <div>
          <Title>
            Loan Management
          </Title>
          <ControlsContainer>
            <SubNav {...subNavProps} />
          </ControlsContainer>
          <Loader number={4} />
        </div>
      )
    }
    if (error) {
      return <Error />
    }
    return (
      <Container noScroll={isCreatePodModalOpen}>
        <Title>
          Loan Management
        </Title>
        <ControlsContainer>
          <SubNav {...subNavProps} />
          <BlueLoadingButton onClick={this.onCreatePodToggle}>
            Create Pod
          </BlueLoadingButton>
        </ControlsContainer>
        <FadeInWrapper>
          <GridContainer id="pod-layout">
            {
              pods.map(pod =>
                <PodCard key={`pod-${pod.rid}`} pod={pod} onPodEdit={this.onPodEdit} />
              )
            }
          </GridContainer>
          <FullscreenModal
            isOpen={isCreatePodModalOpen}
            title={currentEditedPod ? 'Edit Pod' : 'Create Pod'}
            onClose={this.onCreatePodToggle}
            fixed
          >
            <NewPodCard allAdmins={administrators} onCancel={this.onCreatePodToggle} pod={currentEditedPod} />
          </FullscreenModal>
        </FadeInWrapper>
      </Container>
    )
  }
}

const PodsLayoutWithQuery = graphql(PodsQuery, {
  options: {
    variables: {
      role: 'UW'
    }
  },
  notifyOnNetworkStatusChange: true
})(PodsLayout)

export default PodsLayoutWithQuery
